import CartEvents from '../../tracking/cart/CartEvents';
import { register } from '../../core/bootstrapper';

register('cart', function() {
  const cartEvents = new CartEvents({
    el: $('body')
  });

  $(document).ready(function() {
    cartEvents.executeCookieCallbacks();
  });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/cart/trackingBootstrap.js
 **/